/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetWebhookSecretGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type GetWebhookSecretRequest = {
  webhookID: string;
};

export type GetWebhookSecretResponse = {
  headers: { [k: string]: Array<string> };
  result: components.WebhookSecret;
};

/** @internal */
export const GetWebhookSecretGlobals$inboundSchema: z.ZodType<
  GetWebhookSecretGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type GetWebhookSecretGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const GetWebhookSecretGlobals$outboundSchema: z.ZodType<
  GetWebhookSecretGlobals$Outbound,
  z.ZodTypeDef,
  GetWebhookSecretGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function getWebhookSecretGlobalsToJSON(
  getWebhookSecretGlobals: GetWebhookSecretGlobals,
): string {
  return JSON.stringify(
    GetWebhookSecretGlobals$outboundSchema.parse(getWebhookSecretGlobals),
  );
}
export function getWebhookSecretGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<GetWebhookSecretGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetWebhookSecretGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetWebhookSecretGlobals' from JSON`,
  );
}

/** @internal */
export const GetWebhookSecretRequest$inboundSchema: z.ZodType<
  GetWebhookSecretRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  webhookID: z.string(),
});
/** @internal */
export type GetWebhookSecretRequest$Outbound = {
  webhookID: string;
};

/** @internal */
export const GetWebhookSecretRequest$outboundSchema: z.ZodType<
  GetWebhookSecretRequest$Outbound,
  z.ZodTypeDef,
  GetWebhookSecretRequest
> = z.object({
  webhookID: z.string(),
});

export function getWebhookSecretRequestToJSON(
  getWebhookSecretRequest: GetWebhookSecretRequest,
): string {
  return JSON.stringify(
    GetWebhookSecretRequest$outboundSchema.parse(getWebhookSecretRequest),
  );
}
export function getWebhookSecretRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetWebhookSecretRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetWebhookSecretRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetWebhookSecretRequest' from JSON`,
  );
}

/** @internal */
export const GetWebhookSecretResponse$inboundSchema: z.ZodType<
  GetWebhookSecretResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.WebhookSecret$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type GetWebhookSecretResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.WebhookSecret$Outbound;
};

/** @internal */
export const GetWebhookSecretResponse$outboundSchema: z.ZodType<
  GetWebhookSecretResponse$Outbound,
  z.ZodTypeDef,
  GetWebhookSecretResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.WebhookSecret$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function getWebhookSecretResponseToJSON(
  getWebhookSecretResponse: GetWebhookSecretResponse,
): string {
  return JSON.stringify(
    GetWebhookSecretResponse$outboundSchema.parse(getWebhookSecretResponse),
  );
}
export function getWebhookSecretResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetWebhookSecretResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetWebhookSecretResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetWebhookSecretResponse' from JSON`,
  );
}
